import React, { useState, useEffect } from "react";
import * as API from "src/api/plan";
import { useUserContext } from "src/contexts/userContext";
import { usePlanContext } from "src/contexts/planContext";
// import Module from "src/components/custom/module";
import Company from "src/components/Company";

import dayjs from "dayjs";
// import _ from "lodash";
import {
  DatePicker,
  Spin,
  Modal,
  InputNumber,
  Input,
  Select,
  Space,
} from "antd";
import SaveButton from "src/components/button/SaveButton";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import useBearStore from "src/state/state";
import Swal from "sweetalert2";
// import Swal from "sweetalert2";
const { Option } = Select;

const ModalStore = () => {
  const { message } = useUserContext();
  const { state, dispatch } = usePlanContext();
  const [loading, setLoading] = useState(false);

  const [delguur, setDelguur] = useState([]);
  const main_company_id = useBearStore((state) => state.main_company_id);
  const [order, setorder] = useState(0);
  const [type, settype] = useState(1);
  const [list, setList] = useState([]);
  const [user_id, setuser_id] = useState(0);

  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         setLoading(true);

  //         axios
  //           // .get("http://tugeelt.store/api/backend/user")
  //           .put(
  //             "http://localhost:5000/api/backend/orders/delguurupdate" +
  //               state.order.order_id,
  //             // "http://tugeelt.store/api/backend/orders/" +
  //             state.order.order_id,
  //             {
  //               delguur_id: state.order.delguur_id_swap,
  //               delguur_ner: state.order.delguur_id_swap,
  //             }
  //           )
  //           .then((response) => {})
  //           .catch((error) => {
  //             console.error("Error:", error);
  //           });

  //         setLoading(false);
  //       } catch (error) {
  //         setLoading(false);
  //         // setError(error);
  //       }
  //     };

  //     fetchData();
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [state.refresh]);

  const handleClick = () => {
    console.log(state.order.delguur_id_swap, state.order.delguur_ner_swap);
    try {
      axios
        .put(
          "http://tugeelt.store/api/backend/orders/delguurupdate/" +
            // "http://localhost:5000/api/backend/orders/delguurupdate/" +
            state.order.order_id,

          {
            delguur_id: state.order.delguur_id_swap,
            delguur_ner: state.order.delguur_ner_swap,
          },
        )
        .then((response) => {
          dispatch({
            type: "STATE",
            data: { refresh: state.refresh + 1 },
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      Swal.close();
      Swal.fire("Хадгалагдлаа!", "Бүртгэл амжилттай хадгалагдлаа.", "success");
    } catch (error) {}
  };
  return (
    <div className="flex flex-col text-xs">
      <div>
        <h2 className=" text-center text-lg font-extrabold text-gray-900">
          Дэлгүүр засах
        </h2>
      </div>

      <hr className="my-2" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div className="flex p-1 gap-2">
          <div className="w-1/4">Дэлгүүр нэр:</div>
          <div className="w-3/4 text-lg">{state.order.delguur_ner}</div>
        </div>
        <div className="flex p-1 gap-2">
          <div className="w-1/4">Солих дэлгүүр</div>

          <div className="w-3/4">
            <Select
              showSearch
              allowClear
              // value={list}
              placeholder="Сонгоно уу."
              optionFilterProp="children"
              className="w-full"
              onChange={(value, option) => {
                console.log("option", option, value);
                dispatch({
                  type: "ORDER",
                  data: {
                    delguur_id_swap: value,
                    delguur_ner_swap: option?.children[0].trim(),
                  },
                });
              }}
            >
              {_.map(_.orderBy(state.delguur_list, ["delguur_ner"]), (item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.delguur_ner} - {item.d_register}-{item.d_utas}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>

        <Spin
          tip="Уншиж байна. Түр хүлээнэ үү"
          className="bg-opacity-60"
          spinning={loading}
        >
          <SaveButton
            onClick={() => {
              setLoading(true);
              handleClick();
              setLoading(false);
            }}
          />
        </Spin>
      </div>
    </div>
  );
};
export default React.memo(ModalStore);
